<template>
    <div>
        <DaySeparator v-if="evento.tipo == 'divisão_diária'" :timestamp="evento.timestamp" />

        <Mensagem
            v-else
            :show-avatar="showAvatar"
            :evento="evento"
            :sala="sala"
            :perfil="perfil"
            :user-profile="userProfile"
            :contact-profile="contactProfile"
            @select-option="$emit('select-option', $event)"
        />
    </div>
</template>

<script>
import Mensagem from './Mensagem.vue'
import DaySeparator from './DaySeparator.vue'

export default {
    components: { Mensagem, DaySeparator },
    props: ['evento', 'sala', 'showAvatar', 'perfil', 'userProfile', 'contactProfile'],
}
</script>